import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=085c8dda&scoped=true&"
import script from "./CardList.vue?vue&type=script&lang=js&"
export * from "./CardList.vue?vue&type=script&lang=js&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=085c8dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c8dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085c8dda')) {
      api.createRecord('085c8dda', component.options)
    } else {
      api.reload('085c8dda', component.options)
    }
    module.hot.accept("./CardList.vue?vue&type=template&id=085c8dda&scoped=true&", function () {
      api.rerender('085c8dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/CardList.vue"
export default component.exports